export enum TypeOfOperation {
    AddQuantity = 0,
    ReplaceQuantity = 1,
}